import { render } from "./Poster.vue?vue&type=template&id=0b81d4d2&scoped=true&ts=true"
import script from "./Poster.vue?vue&type=script&lang=ts"
export * from "./Poster.vue?vue&type=script&lang=ts"

import "./Poster.vue?vue&type=style&index=0&id=0b81d4d2&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b81d4d2"]])

export default __exports__